import {USER_ROOT_API_URL } from "../../../../config/settings.js"

export const GET_PAGINATED_NEWSFEED = USER_ROOT_API_URL + "/get_paginated_newsfeed";
export const GET_ADMIN_NOTICE = USER_ROOT_API_URL + "/get_admin_notice";